import { useEffect, useState } from "react";
import { diferenciaHora } from "../../helpers/fechaHoras";

export const useContador = (fecha) => {
    
    let timerId = null;
    const [contador, setContador] = useState('00:00:00');

    useEffect(() => {
        return () => detenerContador();
    }, [fecha]);

    const iniciarContador = () => {
        if(!timerId) {
            timerId = setInterval(() => setContador(diferenciaHora(fecha, true)), 1000);
            return;
        }
    }

    const detenerContador = () => {
        clearInterval(timerId);
        setContador('00:00:00');
        timerId = null;
    }

    return {
        contador,
        iniciarContador
    }
};